import styled from 'styled-components';

const StyledButton = styled.button`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 4px;
  background-color: blue;
  color: white;
  font-family: Roboto;
  text-align: center;
  font-size: 26px;
  padding: 10px 20px;
`;

export { StyledButton };
